<template>
  <div>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      class="ml-auto mt-3"
      label="Durchsuchen"
      hide-details
      single-line
      outlined
      clearable
    />
    <v-data-table
      :headers="headers"
      :items="displayedCustomer"
      item-key="name"
      :search.sync="search"
      :sort-by="['createdAt']"
      :sort-desc="[true, false]"
      multi-sort
      :footer-props="footerProps"
      :loading="isLoading"
      loading-text="Loading... Please wait"
    >
      <!--
      <template #header.employees>
        <v-icon>mdi-account-check</v-icon>
      </template>
      -->
      <template #header.phone>
        <v-icon>mdi-phone-classic</v-icon>
      </template>
      <template #header.email>
        <v-icon>mdi-at</v-icon>
      </template>
      <template #header.name>
        <v-icon>mdi-link</v-icon>
      </template>
      <template #header.createdAt>
        <v-icon>mdi-calendar-range</v-icon>
      </template>
      <template #header.state>
        <v-icon>mdi-earth</v-icon>
      </template>
      <template #header.company_name>
        <v-icon>mdi-city</v-icon>
      </template>
      <!-- <template #expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <div class="expanded-panel">
            <div class="header">
              Domain: <span>{{ item.name }}</span>
            </div>
            <div class="header">
              E-Mail: <span>{{ item.email }}</span>
            </div>
            <div class="header">
              RMO-Nr: <span>{{ item.rmo_customer_nr }}</span>
            </div>
            <div class="header">
              Name, Vorname: <span>{{ item.lastName }}, {{ item.firstName }}</span>
            </div>
            <div
              class="action-icons"
            >
              <v-btn
                small
                fab
                class="action-btns"
                color="red"
                outlined
                @click="deleteItem(item)"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </div>
        </td>
      </template>
      <template #top>
        <v-toolbar
          flat
        >
          <v-spacer />

          <v-dialog
            v-model="dialogDelete"
            width="700"
          >
            <v-card>
              <v-card-title class="headline">
                Are you sure you want to delete this item?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  OK
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template> -->
      <!-- eslint-disable-next-line -->
      <template #body.append="{ headers }">
        <td :colspan="headers.length - 1">
          <div class="d-flex align-center justify-end">
            <div class="d-flex mx-4 my-0 align-center">
              <v-checkbox
                v-model="ram"
                label="RA-MICRO Kunden"
                class="mr-2"
                color="red"
                dense
                @change="filterCustomers()"
              />
              <v-checkbox
                v-model="law"
                label="Jura Kunden"
                class="mr-2"
                color="red"
                dense
                @change="filterCustomers()"
              />
              <v-checkbox
                v-model="german"
                label="Deutsche Unternehmen"
                class="mr-2"
                color="red"
                dense
                @change="filterCustomers()"
              />
              <v-checkbox
                v-model="foreign"
                label="Alle nicht deutsche Unternehmen"
                class="mr-2"
                color="red"
                dense
                @change="filterCustomers()"
              />
            </div>
            <domain-range-setting
              @change-date-setting="setDateRange"
            />
            <download-excel-component
              :ram="ram"
              :law="law"
              :german="german"
              :foreign="foreign"
            />
          </div>
        </td>
      </template>
      <template #item.createdAt="{ item }">
        {{ item.date_formated }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  // import { devNuke } from '@/api/devNuke'
  // import SetCompayDetailsForm from '../forms/SetCompanyDetailsForm'
  import DownloadExcelComponent from '../component/DownloadExcelComponent'
  import DomainRangeSetting from '../component/DomainsRangeSetting'
  import { getFirebaseToken } from '@/firebase'

  export default {

    components: {
      // SetCompayDetailsForm,
      DownloadExcelComponent,
      DomainRangeSetting,
    },
    data: () => ({
      headers: [
        {
          text: 'Datum',
          align: 'start',
          value: 'createdAt',
          sortable: true,
        },
        { text: 'Kanzlei- Firmenname', value: 'company_name' },
        { text: 'Domain', value: 'name' },
        { text: 'Land', value: 'state' },
        { text: 'E-Mail', value: 'email' },
        { text: 'RMO', value: 'rmo_customer_nr' },
        // { text: 'User', value: 'employees' },
        { text: 'Telefon', value: 'phone' },
        { text: '', value: 'data-table-expand' },
      ],
      footerProps: {
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      },
      search: undefined,
      customers: [],
      displayedCustomer: [],
      endDate: new Date(),
      startDate: new Date(),
      ram: true,
      law: true,
      german: true,
      foreign: true,
      isLoading: false,
    }),
    mounted () {
      this.startDate.setDate(1)
      this.startDate = this.startDate.toISOString().slice(0, 10)
      this.endDate = this.endDate.toISOString().slice(0, 10)
      this.loadCustomers()
    },

    methods: {

      // async deleteItemConfirm () {
      //   if (this.$can('write', 'domain')) {
      //     this.$store.getters.items.splice(this.editedIndex, 1)
      //     const res = await devNuke(this.editedItem.name.split('.')[0], this.$store.user.user.email)
      //     console.log(res)
      //     fetch(`${process.env.VUE_APP_FUNCTIONS}/deleteCustomer`, {
      //       method: 'POST',
      //       headers: {
      //         Authorization: 'Bearer ' + (await getFirebaseToken()),
      //         'Content-Type': 'application/json;charset=UTF-8',
      //       },
      //       body: JSON.stringify({
      //         domain: this.editedItem.name,
      //       }),
      //     })

      //     this.closeDelete()
      //   }
      // },

      async setDateRange (dates) {
        this.startDate = dates[0]
        this.endDate = dates[1]
        this.loadCustomers()
      },

      filterCustomers () {
        this.displayedCustomer = []
        if (this.ram) {
          const ramCustomer = this.customers.filter(item => item.domainLink.split('.')[1] === 'ra-micro' && (/^\+?\d+$/.test(item.domainLink.split('.')[0].split('_')[1]) || /^\+?\d+$/.test(item.domainLink.split('.')[0].split('-')[1])))
          this.displayedCustomer.push.apply(this.displayedCustomer, ramCustomer)
        }
        if (this.law) {
          const lawCustomer = this.customers.filter(item => item.domainLink.split('.')[1] === 'ra-micro' && !(/^\+?\d+$/.test(item.domainLink.split('.')[0].split('_')[1]) || /^\+?\d+$/.test(item.domainLink.split('.')[0].split('-')[1])))
          this.displayedCustomer.push.apply(this.displayedCustomer, lawCustomer)
        }
        if (this.german) {
          const germanCustomer = this.customers.filter(item => item.domainLink.split('.')[1] === 'voffice' && (item.state === 'DE' || item.state?.value === 'DE' || item.state === 'Deutschland'))
          this.displayedCustomer.push.apply(this.displayedCustomer, germanCustomer)
        }
        if (this.foreign) {
          const foreignCustomer = this.customers.filter(item => item.domainLink.split('.')[1] === 'voffice' && !(item.state === 'DE' || item.state?.value === 'DE' || item.state === 'Deutschland'))
          this.displayedCustomer.push.apply(this.displayedCustomer, foreignCustomer)
        }
      },

      async loadCustomers () {
        this.isLoading = true

        const response = await fetch(`${process.env.VUE_APP_FUNCTIONS}/allCustomers/${this.startDate}:${this.endDate}`, {
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + (await getFirebaseToken()),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        })
        const responseJson = await response.json()

        if (responseJson.success) {
          this.customers = []
          Object.entries(responseJson.results).forEach(entry => {
            const key = entry[0]
            const customer = entry[1]

            const tempObject = {
              domainLink: key,
              date_formated: this.moment(customer.createdAt).locale('de').format('DD.MM.YYYY'),
              ...customer,
            }
            this.customers.push(tempObject)
          })
          this.filterCustomers()
          this.isLoading = false
        } else {
          console.log(response.message)
        }
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.items[this.editedIndex], this.editedItem)
        } else {
          this.items.push(this.editedItem)
        }
        this.close()
      },

    },

  }
</script>
<style scoped lang='scss'>
.action-btns {
  margin-right: 1rem !important;
}
.action-icons {
  display: flex;
  border: none !important;
}
.expanded-panel {
  display: flex;
  margin: 1rem;
  justify-content: space-between;
  align-items: center;
}
.header {
  font-weight: bold;
  & > span {
    font-weight: normal;
    display: block;
  }
}
</style>
